import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlogFeed from './BlogFeed.component';

const BlogDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Blog/Blog.dispatcher'
);

export const mapStateToProps = state => ({
    blog: state.BlogReducer,
    code: state.ConfigReducer.code
});

export const mapDispatchToProps = dispatch => ({
    getPosts: () => BlogDispatcher.then(
        ({ default: dispatcher }) => dispatcher.requestPosts(dispatch)
    )
});

class BlogFeedContainer extends PureComponent {
    static propTypes = {
        getPosts: PropTypes.func.isRequired
    };

    componentDidMount() {
        const { getPosts } = this.props;
        getPosts();
    }

    render() {
        const { blog: { posts, isLoading }, code } = this.props;

        return <BlogFeed posts={ posts } isLoading={ isLoading } code={ code } />;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BlogFeedContainer);
